import * as bootstrap from "bootstrap";
import { waitForAtLeast } from "../../utils";
import { EventBus, Events } from "../eventBus";
import { ElemID, PLACEHOLDER_MIN_DELAY } from "./constants";
import { generatePDFWithAnnotations } from "./pdf";

const previewButton = document.getElementById(ElemID.PREVIEW_BUTTON);
const cancelButton = document.getElementById(ElemID.CANCEL_BUTTON);
const backButton = document.getElementById(ElemID.BACK_BUTTON);
const exportButton = document.getElementById(ElemID.EXPORT_BUTTON);
const forceCancelButton = document.getElementById(ElemID.FORCE_CANCEL_BUTTON);
const cancelConfirmationModal = new bootstrap.Modal(
  "#" + ElemID.CANCEL_CONFIRMATION_MODAL,
);

const editorZoomButton = document.getElementById("zoom-button");
const editorZoomMenu = document.getElementById("zoom-dropdown-menu");
const previewZoomMenu = document.getElementById("preview-zoom-dropdown-menu");
const previewZoomButton = document.getElementById("preview-zoom-button");

export function initEditorButtons() {
  cancelButton.addEventListener("click", handleCancel);
  exportButton.addEventListener("click", handleExport);
  previewButton.addEventListener("click", handlePreview);
  backButton.addEventListener("click", cancelPreview);
  forceCancelButton.addEventListener("click", doCancel);

  setupZoomMenus();
}

// Keep track of annotations, so we can adjust button states accordingly
let annotationCount = 0;

EventBus.subscribe(Events.ANCHOR_ADDED, function () {
  annotationCount++;
  updateButtonStates();
});

EventBus.subscribe(Events.ANCHOR_DELETED, function () {
  annotationCount--;
  updateButtonStates();
});

function updateButtonStates() {
  console.debug(`Total annotations: ${annotationCount}`);
  if (annotationCount > 0) {
    previewButton.removeAttribute("disabled");
  } else {
    previewButton.setAttribute("disabled", "disabled");
  }
}

function handleCancel() {
  if (annotationCount > 0) {
    cancelConfirmationModal.show();
  } else {
    doCancel();
  }
}

function doCancel() {
  window.location.reload();
}

async function handleExport() {
  EventBus.emit(Events.HIDE_PREVIEW);
  EventBus.emit(Events.SHOW_PLACEHOLDER_GENERATING_PDF);
  const payload = await waitForAtLeast(
    PLACEHOLDER_MIN_DELAY,
    generatePDFWithAnnotations(),
  );

  EventBus.emit(Events.HIDE_PLACEHOLDER);
  EventBus.emit(Events.EXPORT_DONE, {
    data: payload.data,
    filename: payload.filename,
  });
}

function handlePreview() {
  EventBus.emit(Events.SHOW_PREVIEW);
}

function cancelPreview() {
  EventBus.emit(Events.HIDE_PREVIEW);
}

EventBus.subscribe(Events.PAGE_IN_VIEW, function (payload) {
  const elemId =
    payload.screen === "preview"
      ? "preview-page-counter-current-page"
      : "page-counter-current-page";
  document.getElementById(elemId).textContent = payload.page;
});

function setupZoomMenus() {
  addZoomHandlers("editor");
  addZoomHandlers("preview");

  function addZoomHandlers(screen) {
    const menuElement = screen === "preview" ? previewZoomMenu : editorZoomMenu;
    menuElement.querySelectorAll(".dropdown-item").forEach(function (element) {
      element.addEventListener("click", function () {
        EventBus.emit(Events.ZOOM_VALUE_UPDATED, {
          zoom: element.dataset.zoomValue,
          screen: screen,
        });
      });
    });
  }

  EventBus.subscribe(Events.SCALE_CHANGED, function (payload) {
    const menuElement =
      payload.screen === "preview" ? previewZoomMenu : editorZoomMenu;
    const buttonElement =
      payload.screen === "preview" ? previewZoomButton : editorZoomButton;

    // update text in zoom button
    buttonElement.textContent = payload.zoom + "%";

    // highlight selected option
    const selectedZoom = payload.autoFit ? "fit" : "" + payload.zoom;
    menuElement.querySelectorAll("a.dropdown-item").forEach(function (element) {
      if (element.dataset.zoomValue === selectedZoom) {
        element.classList.add("active");
      } else {
        element.classList.remove("active");
      }
    });
  });
}
